import type { FC } from 'react';
import { cx } from '../../../utils/cx';
import type { AlertProps } from './alerts.types';
import { alertColorVariants, defaultIcons } from './alerts.constants';
import {
  AlertIcon,
  AlertCloseButton,
  AlertActions
} from './alert-sub-components';

export const FloatingAlert: FC<AlertProps> = ({
  color = 'gray',
  title,
  description,
  showCloseButton = false,
  onClose,
  dismissText,
  onDismiss,
  actionText,
  onAction,
  className,
  children
}) => {
  const colors = alertColorVariants[color];
  const Icon = defaultIcons[color];

  return (
    <div
      className={cx(
        'relative flex w-full gap-(--gn-spacing-xl) rounded-(--gn-spacing-xl) border p-(--gn-spacing-xl) shadow-xs',
        colors.floating,
        className
      )}
    >
      {showCloseButton && (
        <AlertCloseButton onClick={onClose} className={colors.closeButton} />
      )}
      <AlertIcon
        icon={Icon}
        iconClass={colors.icon}
        ringClass={colors.iconRing}
      />
      <div className="flex min-w-0 flex-1 flex-col gap-(--gn-spacing-lg)">
        <div className="flex flex-col gap-(--gn-spacing-xs)">
          {title && (
            <p
              className={cx(
                'break-words pr-(--gn-spacing-4xl) text-sm font-semibold',
                colors.title
              )}
            >
              {title}
            </p>
          )}
          {description && (
            <p
              className={cx(
                'break-words text-xs font-normal',
                colors.description
              )}
            >
              {description}
            </p>
          )}
          {children}
        </div>
        <AlertActions
          dismissText={dismissText}
          onDismiss={onDismiss}
          actionText={actionText}
          onAction={onAction}
          dismissClass={colors.dismissButton}
          actionClass={colors.actionButton}
        />
      </div>
    </div>
  );
};
